export default __webpack_public_path__ + "static/media/slot22.86adcb24.png";